import React from 'react'

function IconPpt({ className = '' }) {
    return (
        <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                d='M44.8156 11.1844C43.7312 9.70625 42.2188 7.975 40.5594 6.31562C38.9 4.65625 37.1687 3.14375 35.6906 2.05938C33.1719 0.2125 31.95 0 31.25 0H7.03125C4.87812 0 3.125 1.75312 3.125 3.90625V46.0938C3.125 48.2469 4.87812 50 7.03125 50H42.9688C45.1219 50 46.875 48.2469 46.875 46.0938V15.625C46.875 14.925 46.6625 13.7031 44.8156 11.1844ZM38.3469 8.52813C39.8469 10.0281 41.0219 11.3781 41.8906 12.5H34.3719V4.98438C35.4937 5.85313 36.85 7.02813 38.3469 8.52813ZM43.75 46.0938C43.75 46.5187 43.3937 46.875 42.9688 46.875H7.03125C6.82481 46.8726 6.6275 46.7895 6.48151 46.6435C6.33553 46.4975 6.25243 46.3002 6.25 46.0938V3.90625C6.25 3.48438 6.60938 3.125 7.03125 3.125H31.25V14.0625C31.25 14.4769 31.4146 14.8743 31.7076 15.1674C32.0007 15.4604 32.3981 15.625 32.8125 15.625H43.75V46.0938Z'
                fill='#FF0100'
            />
            <path
                d='M12.1699 23.29H16.9399C18.8749 23.29 20.1499 24.355 20.1499 26.455C20.1499 28.585 18.8449 29.62 17.0299 29.62H13.5949V34H12.1699V23.29ZM13.5949 28.42H16.5349C17.8849 28.42 18.7249 27.79 18.7249 26.455C18.7249 25.135 17.9449 24.49 16.4449 24.49H13.5949V28.42Z'
                fill='#FF0100'
            />
            <path
                d='M21.8965 23.29H26.6665C28.6015 23.29 29.8765 24.355 29.8765 26.455C29.8765 28.585 28.5715 29.62 26.7565 29.62H23.3215V34H21.8965V23.29ZM23.3215 28.42H26.2615C27.6115 28.42 28.4515 27.79 28.4515 26.455C28.4515 25.135 27.6715 24.49 26.1715 24.49H23.3215V28.42Z'
                fill='#FF0100'
            />
            <path d='M30.483 23.29H39.048V24.49H35.478V34H34.053V24.49H30.483V23.29Z' fill='#FF0100' />
        </svg>
    )
}

export default IconPpt
